export default "__VITE_ASSET__DBNE8aTh__"